import React, { Component } from "react";
import { Row, Col, Container, Form, Modal } from "react-bootstrap";
import MultiSelect from "react-multi-select-component";
import * as Cookies from "es-cookie";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import AssignTestModal from "./AssignTestModal";
import "./_admissionForms.scss";

const DELETE_ENQUIRY_FORM = gql`
  mutation ($id: Int!) {
    removeEnquiryForm(id: $id)
  }
`;

const GET_ENQUIRY_FORMS = gql`
  query ($institute_id: Int!, $branch_id: Int!) {
    getEnquiryForms(institute_id: $institute_id, branch_id: $branch_id) {
      form_name
      id
      lead_count
      source_details {
        source_name
        source_count
      }
    }
  }
`;

const GET_ENQUIRY_FORM_FIELDS = gql`
  query ($form_id: Int!) {
    getEnquiryFormFields(form_id: $form_id) {
      id
      field_name
    }
  }
`;

class AdmissionFormsHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedBranches: [],
      branchError: "",
      loader: false,
      admissionFormData: [],
      noDataError: "",

      // Create/Edit form modal
      showModal: false,
      editingForm: null,
      currentBranchId: "",

      // Copy link
      copySuccess: {},

      // Assign Test modal
      showAssignModal: false,
      selectedStudent: null,

      // Delete Form Modal
      showDeleteModal: false,
      formToDelete: null,
      formToDeleteName: "",
      deleteConfirmationText: "",
      deleting: false,
    };
  }

  componentDidMount() {
    this.initBranches();
  }

  componentDidUpdate(prevProps) {
    const branches = this.props.globals && this.props.globals.globalBranches;
    const prevBranches = prevProps.globals && prevProps.globals.globalBranches;
    if (branches && branches !== prevBranches && this.state.selectedBranches.length === 0) {
      this.initBranches();
    }
  }

  initBranches = () => {
    const branches = this.props.globals && this.props.globals.globalBranches;
    if (branches && branches.length > 0) {
      let authorizedIds = [];
      try {
        const cookie = Cookies.get("branch_id");
        const parsed = cookie ? JSON.parse(cookie) : [];
        authorizedIds = Array.isArray(parsed) ? parsed : [parsed];
      } catch (e) {
        try {
          const cookie = Cookies.get("branch_id");
          authorizedIds = cookie ? cookie.split(",").map(id => id.trim()) : [];
        } catch (err) { console.error(err); }
      }
      authorizedIds = authorizedIds.map(String);

      const selected = branches
        .filter(b => authorizedIds.includes("all") || authorizedIds.includes(String(b.id)))
        .map((b) => ({
          label: b.branch_name,
          value: b.id,
        }));
      this.setState({ selectedBranches: selected }, () => {
        this.fetchForms(selected);
      });
    }
  }

  handleBranchChange = (selected) => {
    this.setState({
      selectedBranches: selected,
      branchError: "",
      admissionFormData: [],
      noDataError: "",
    }, () => {
      if (selected && selected.length > 0) {
        this.fetchForms(selected);
      } else {
        this.setState({ noDataError: "Please select at least one branch to view admission forms." });
      }
    });
  };

  fetchForms = async (branches) => {
    if (!branches || branches.length === 0) {
      this.setState({ branchError: "Please select at least one branch" });
      return;
    }
    this.setState({
      loader: true,
      admissionFormData: [],
      noDataError: "",
      branchError: "",
    });

    try {
      const promises = branches.map((branch) =>
        this.props.client
          .query({
            query: GET_ENQUIRY_FORMS,
            variables: {
              institute_id: parseInt(Cookies.get("institutionid")),
              branch_id: parseInt(branch.value),
            },
            fetchPolicy: "network-only",
          })
          .then(async (result) => {
            const rawForms = result.data.getEnquiryForms || [];

            // For each form, fetch its field names and compute form_url client-side
            const enrichedForms = await Promise.all(
              rawForms.map(async (f) => {
                let fieldNames = [];
                try {
                  const fieldsResult = await this.props.client.query({
                    query: GET_ENQUIRY_FORM_FIELDS,
                    variables: { form_id: f.id },
                    fetchPolicy: "network-only",
                  });
                  fieldNames = (
                    fieldsResult.data.getEnquiryFormFields || []
                  ).map((field) => field.field_name);
                } catch (e) {
                  console.log("Could not fetch fields for form", f.id);
                }

                return {
                  ...f,
                  form_url: `https://rizee.in/admission-form/${f.id}`,
                  fieldNames,
                  existing_form_field_id: f.id,
                  branch_id: branch.value,
                };
              }),
            );

            return {
              branch_name: branch.label,
              branch_id: branch.value,
              forms: enrichedForms,
            };
          }),
      );

      const results = await Promise.all(promises);
      const withData = results.filter((r) => r.forms.length > 0);

      if (withData.length > 0) {
        this.setState({ admissionFormData: withData, loader: false });
      } else {
        this.setState({
          loader: false,
          noDataError: "No admission forms found for the selected branch(es).",
        });
      }
    } catch (err) {
      this.setState({
        loader: false,
        noDataError: "Failed to load data. Please try again.",
      });
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.fetchForms(this.state.selectedBranches);
  };

  openDeleteModal = (id, name) => {
    this.setState({
      showDeleteModal: true,
      formToDelete: id,
      formToDeleteName: name,
      deleteConfirmationText: "",
    });
  };

  closeDeleteModal = () => {
    this.setState({
      showDeleteModal: false,
      formToDelete: null,
      formToDeleteName: "",
      deleteConfirmationText: "",
    });
  };

  confirmDelete = async () => {
    const { formToDelete } = this.state;
    if (!formToDelete) return;

    this.setState({ deleting: true });
    try {
      await this.props.removeEnquiryForm({ variables: { id: formToDelete } });
      window.location.reload(false);
    } catch (err) {
      alert("Error deleting form. Please try again.");
      this.setState({ deleting: false });
    }
  };

  handleCopy = (url) => {
    navigator.clipboard.writeText(url).then(() => {
      this.setState({ copySuccess: { [url]: true } });
      setTimeout(() => this.setState({ copySuccess: { [url]: false } }), 2000);
    });
  };

  resolveFieldNames = (item) => {
    // These 6 fields are standard mandatory fields for all forms
    const standardMandatory = ["Name", "Mobile", "Date of Birth", "Gender", "Course Name", "Email"];

    // item.fieldNames contains ALL field names fetched per-form.
    // We need to split mandatory vs optional, and deduplicate.
    const allNames = item.fieldNames || [];
    const isMandatoryMatch = (name) => {
      const l = (name || "").toLowerCase().trim();
      return (
        l === "name" ||
        l === "student name" ||
        l === "mobile" ||
        l === "mobile number" ||
        l === "student mobile" ||
        l.includes("email") ||
        l.includes("gender") ||
        l === "date of birth" ||
        l === "dob" ||
        l === "course name" ||
        l === "course"
      );
    };

    const seen = new Set();
    const mandatory = [];
    const optional = [];

    // Always include the standard 6 first
    standardMandatory.forEach(m => {
      mandatory.push(m);
      seen.add(m.toLowerCase());
    });

    allNames.forEach((n) => {
      const l = (n || "").toLowerCase().trim();
      if (seen.has(l)) return;
      seen.add(l);

      if (isMandatoryMatch(n)) {
        mandatory.push(n);
      } else {
        optional.push(n);
      }
    });

    return { mandatory, optional };
  };

  openCreate = () => {
    const { selectedBranches } = this.state;
    let branchId = "";
    if (selectedBranches && selectedBranches.length > 0) {
      branchId = selectedBranches[0].value;
    }
    this.props.history.push({
      pathname: "/admission-forms/create",
      state: { branch_id: branchId },
    });
  };

  openEdit = (item) => {
    this.props.history.push({
      pathname: `/admission-forms/edit/${item.existing_form_field_id}`,
      state: {
        existingAdmissionFormFields: [item],
        branch_id: item.branch_id,
      },
    });
  };

  closeModal = () => {
    this.setState({ showModal: false, editingForm: null });
  };

  // ── Fill Form ──────────────────────────────
  openCreateStudent = (item, branchId) => {
    this.props.history.push({
      pathname: `/admission-forms/fill/${item.id}`,
      state: { form_name: item.form_name, branch_id: branchId },
    });
  };

  // ── Assign Test (from card directly) ─────────
  openAssignModal = (student) => {
    this.setState({ showAssignModal: true, selectedStudent: student });
  };

  closeAssignModal = () => {
    this.setState({ showAssignModal: false, selectedStudent: null });
  };

  render() {
    const {
      admissionFormData,
      loader,
      noDataError,
      showModal,
      editingForm,
      copySuccess,
      selectedBranches,
      showAssignModal,
      selectedStudent,
    } = this.state;
    const { globals } = this.props;

    let authorizedIds = [];
    try {
      const cookie = Cookies.get("branch_id");
      const parsed = cookie ? JSON.parse(cookie) : [];
      authorizedIds = Array.isArray(parsed) ? parsed : [parsed];
    } catch (e) {
      try {
        const cookie = Cookies.get("branch_id");
        authorizedIds = cookie ? cookie.split(",").map(id => id.trim()) : [];
      } catch (err) { console.error(err); }
    }
    authorizedIds = authorizedIds.map(String);

    const branchOptions = (
      globals && globals.globalBranches ? globals.globalBranches : []
    ).filter(b => authorizedIds.includes("all") || authorizedIds.includes(String(b.id)))
     .map((b) => ({ 
       label: b.branch_name || `Branch ${b.id}`, 
       value: b.id 
     }));

    const modalStateData = {
      existingAdmissionFormFields: editingForm ? [editingForm] : [],
      branch_id: this.state.currentBranchId,
    };

    const totalForms = admissionFormData.reduce(
      (sum, g) => sum + g.forms.length,
      0,
    );

    return (
      <Container fluid className="px-4 pb-5">
        <style>{`
          /* Aggressive CSS Reset for ANY MultiSelect Library */
          div[class*="rmsc"], div[class*="multi-select"], div[class*="dropdown-content"] {
            --rmsc-bg: #fff !important;
            --rmsc-hover: #f1f5f9 !important;
            --rmsc-border: #e2e8f0 !important;
          }
          
          /* Target Select Container */
          div[class*="dropdown-container"] {
            border-radius: 6px !important;
            border-color: #e2e8f0 !important;
            min-height: 40px !important;
            background: #fff !important;
          }

          /* Target Dropdown Items */
          div[class*="dropdown-content"] {
             background: #fff !important;
             border-radius: 6px !important;
             box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1) !important;
             border: 1px solid #e2e8f0 !important;
             z-index: 9999 !important;
          }

          div[class*="dropdown-content"] *, 
          div[class*="dropdown-content"] label,
          div[class*="dropdown-content"] li,
          div[class*="item-renderer"],
          div[class*="select-item"] {
            background-color: transparent !important;
            background: transparent !important;
            border: none !important;
            box-shadow: none !important;
            color: #334155 !important;
          }

          /* Hover State */
          div[class*="dropdown-content"] label:hover,
          div[class*="dropdown-content"] li:hover,
          div[class*="select-item"]:hover {
            background-color: #f1f5f9 !important;
            background: #f1f5f9 !important;
          }

          /* Search bar */
          div[class*="dropdown-content"] input[type="text"] {
             background-color: #f8fafc !important;
             border: 1px solid #e2e8f0 !important;
             border-radius: 4px !important;
             margin: 4px !important;
             padding: 8px !important;
          }

          .af-dash-multiselect .rmsc { --rmsc-main: #3b82f6; --rmsc-hover: #f1f5f9; --rmsc-selected: #e2e8f0; --rmsc-border: #cbd5e1; --rmsc-gray: #64748b; --rmsc-bg: #fff; }
          .af-dash-multiselect .dropdown-container { border: 1px solid #cbd5e1; border-radius: 6px; }

          .badge-soft-success { background-color: #dcfce7; color: #166534; }
          .badge-soft-warning { background-color: #fef3c7; color: #92400e; }

          @media print {
            .header-area, #sidebar, .af-filter-bar, .btn { display: none !important; }
            .main-wrapper { margin-left: 0 !important; }
            .content-wrapper { padding: 0 !important; }
          }
        `}</style>

        {/* ── Breadcrumb Navigation ── */}
        <ul className="af-breadcrumb mt-4">
          <li className="af-bc-item">
            <a href="#/admissions-dashboard" onClick={(e) => { e.preventDefault(); this.props.history.push("/admissions-dashboard"); }}>
              Admissions
            </a>
          </li>
          <li className="af-bc-item active">Forms</li>
        </ul>
        {/* ── Dashboard Header & Filter ─────────────────────────────── */}
        <div
          className="af-admin-header mt-4 mb-4 pb-3 border-bottom d-flex flex-column flex-xl-row justify-content-between align-items-start align-items-xl-center"
          style={{ gap: "16px" }}
        >
          <div>
            <h4 className="font-weight-bold mb-1" style={{ color: "#0f172a" }}>
              <i className="fas fa-folder-open mr-2 text-primary opacity-75" />
              Manage Admission Forms
            </h4>
            <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
              View and manage admission forms configurations and entries across
              branches.
            </p>
          </div>

          <div
            className="d-flex flex-column flex-md-row align-items-start align-items-md-center w-100"
            style={{ gap: "16px", flex: 1, justifyContent: "flex-end" }}
          >
            <div
              className="d-flex align-items-center pb-0 border-right-0 border-md-right pr-0 pr-md-3 mr-0 mr-md-2"
              style={{ gap: "8px" }}
            >
              <button
                className="af-save-btn d-flex align-items-center"
                onClick={this.openCreate}
                style={{ height: "38px", gap: "8px" }}
              >
                <i className="fas fa-plus"></i> Create New Form
              </button>
            </div>
            <div
              className="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center m-0"
              style={{ gap: "12px" }}
            >
              <div style={{ width: branchOptions.length > 1 ? "260px" : "auto", maxWidth: "100%" }}>
                {branchOptions.length > 1 ? (
                  <MultiSelect
                    options={branchOptions}
                    value={selectedBranches}
                    onChange={this.handleBranchChange}
                    labelledBy="Select Branches"
                    overrideStrings={{
                      allItemsAreSelected: "All Branches",
                      selectSomeItems: "Filter by branch...",
                    }}
                    className="af-dash-multiselect"
                  />
                ) : (
                  <div className="d-flex align-items-center py-2 px-3 bg-light rounded border" style={{ gap: "8px", fontSize: "14px", color: "#475569" }}>
                    <i className="fas fa-building text-primary opacity-75" />
                    <strong>Branch:</strong> {branchOptions.length > 0 ? branchOptions[0].label : (globals?.globalBranches?.length > 0 ? "No authorized branches found" : "Loading branches...")}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* ---- Loading ---- */}
        {loader && (
          <div className="af-cards-grid mt-4">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="af-shadcn-card d-flex flex-column h-100 p-4" style={{ height: "300px" }}>
                <div className="d-flex justify-content-between mb-4">
                  <div className="w-75">
                    <span className="af-skeleton-box w-50 mb-2" style={{ height: "12px", display: "block" }}></span>
                    <span className="af-skeleton-box w-100" style={{ height: "20px", display: "block" }}></span>
                  </div>
                  <span className="af-skeleton-box" style={{ width: "40px", height: "24px", borderRadius: "99px" }}></span>
                </div>
                <span className="af-skeleton-box w-50 mb-2" style={{ height: "14px", display: "block" }}></span>
                <span className="af-skeleton-box w-25 mb-4" style={{ height: "14px", display: "block" }}></span>
                
                <span className="af-skeleton-box w-100 mb-2" style={{ height: "12px", display: "block" }}></span>
                <span className="af-skeleton-box w-100 mb-2" style={{ height: "12px", display: "block" }}></span>
                <span className="af-skeleton-box w-75 mb-4" style={{ height: "12px", display: "block" }}></span>
                
                <div className="mt-auto pt-3 border-top" style={{ display: "flex", gap: "8px", flexDirection: "column" }}>
                   <div className="d-flex w-100" style={{ gap: "8px" }}>
                     <span className="af-skeleton-box w-100" style={{ height: "32px" }}></span>
                     <span className="af-skeleton-box w-100" style={{ height: "32px" }}></span>
                     <span className="af-skeleton-box w-100" style={{ height: "32px" }}></span>
                   </div>
                   <span className="af-skeleton-box w-100" style={{ height: "38px" }}></span>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* ---- Empty / Error ---- */}
        {!loader && noDataError && (
          <div className="af-empty-state">
            <i className="fas fa-folder-open af-empty-icon" />
            <h6>No Forms Found</h6>
            <p>{noDataError}</p>
          </div>
        )}

        {/* ---- Form Cards ---- */}
        {!loader && admissionFormData.length > 0 && (
          <>
            <p className="af-results-summary">
              {totalForms} form{totalForms !== 1 ? "s" : ""}
              &nbsp;&middot;&nbsp;
              {admissionFormData.length} branch
              {admissionFormData.length !== 1 ? "es" : ""}
            </p>

            {admissionFormData.map((group) => (
              <div key={group.branch_id} className="af-branch-group">
                <div className="af-branch-banner">
                  <i className="fas fa-building" />
                  {group.branch_name}
                  <span className="af-branch-count">
                    {group.forms.length} form
                    {group.forms.length !== 1 ? "s" : ""}
                  </span>
                </div>

                <div className="af-cards-grid">
                  {group.forms.map((item, index) => {
                    const fieldNames = this.resolveFieldNames(item);
                    const isCopied = copySuccess[item.form_url];

                    return (
                      <div
                        className="af-shadcn-card d-flex flex-column h-100"
                        key={item.existing_form_field_id}
                      >
                        {/* Card Header */}
                        <div className="af-shadcn-card-header pb-0 border-bottom-0 d-flex flex-row justify-content-between align-items-start">
                          <div>
                            <div
                              className="text-uppercase font-weight-bold text-muted mb-1"
                              style={{ fontSize: "11px", letterSpacing: "1px" }}
                            >
                              Form #{index + 1}
                            </div>
                            <h6
                              className="af-shadcn-card-title m-0 text-truncate"
                              style={{ maxWidth: "200px" }}
                              title={item.form_name}
                            >
                              {item.form_name}
                            </h6>
                          </div>
                          {/* Lead count — clickable to view submissions */}
                          <span
                            className="badge badge-light d-flex align-items-center py-2 px-3 border shadow-sm cursor-pointer"
                            title="View submitted students"
                            onClick={() =>
                              this.props.history.push({
                                pathname: `/admission-forms/registrations/${item.id}`,
                                state: { form_name: item.form_name },
                              })
                            }
                            style={{ gap: "6px", fontSize: "13px", fontWeight: "600", color: "#334155", borderRadius: "100px" }}
                          >
                            <i className="fas fa-users text-primary" />
                            {item.lead_count ?? 0}
                          </span>
                        </div>

                        {/* Fields */}
                        {(() => {
                          const { mandatory, optional } =
                            this.resolveFieldNames(item);
                          const totalFields =
                            mandatory.length + optional.length;
                          return (
                            <div className="af-card-body af-shadcn-card-content d-flex flex-column flex-grow-1 pt-4">
                              <div className="af-card-label">
                                Form Fields ({totalFields})
                              </div>

                              {/* — Mandatory section — */}
                              <div className="af-fields-section">
                                <div className="af-fields-section-label af-fields-section-label--mandatory">
                                  Mandatory
                                </div>
                                <div className="af-fields-wrap">
                                  {mandatory.map((name, i) => (
                                    <span
                                      key={i}
                                      className="af-field-badge af-field-mandatory"
                                    >
                                      {name}
                                    </span>
                                  ))}
                                </div>
                              </div>

                              {/* — Optional section — */}
                              {optional.length > 0 && (
                                <div className="af-fields-section">
                                  <div className="af-fields-section-label">
                                    Additional
                                  </div>
                                  <div className="af-fields-wrap">
                                    {optional.map((name, i) => (
                                      <span key={i} className="af-field-badge">
                                        <span className="af-field-num">
                                          {i + 1}.
                                        </span>
                                        {name}
                                      </span>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        })()}

                        {/* Actions */}
                        <div className="af-card-footer flex-column" style={{ gap: "8px", padding: "16px" }}>
                          <div className="d-flex w-100" style={{ gap: "8px" }}>
                            <button
                              className="af-action-btn border-danger-subtle text-danger"
                              onClick={() =>
                                this.openDeleteModal(
                                  item.existing_form_field_id,
                                  item.form_name,
                                )
                              }
                              title="Delete this form"
                              style={{ backgroundColor: "#fef2f2" }}
                            >
                              <i className="fas fa-trash-alt" />
                              Delete
                            </button>

                            <button
                              className="af-action-btn"
                              onClick={() => this.handleCopy(item.form_url)}
                              title="Copy form link"
                            >
                              <i
                                className={`fas ${isCopied ? "fa-check text-success" : "fa-copy text-muted"}`}
                              />
                              {isCopied ? "Copied!" : "Copy"}
                            </button>

                            <button
                              className="af-action-btn"
                              onClick={() => {
                                this.setState({
                                  currentBranchId: group.branch_id,
                                });
                                this.openEdit(item);
                              }}
                              title="Edit this form"
                            >
                              <i className="fas fa-edit text-muted" />
                              Edit
                            </button>
                          </div>
                          
                          <button
                            className="af-action-btn w-100 border-primary"
                            onClick={() =>
                              this.openCreateStudent(item, group.branch_id)
                            }
                            title="Fill out this form for a student"
                            style={{ backgroundColor: "#213046", color: "#fff", height: "38px", fontSize: "14px", fontWeight: "600", border: "none" }}
                          >
                            <i className="fas fa-pencil-alt text-white mr-2" />
                            Fill Form
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </>
        )}



        {/* ---- Assign Test Modal (direct from card) ---- */}
        <AssignTestModal
          show={showAssignModal}
          onHide={this.closeAssignModal}
          student={selectedStudent}
        />

        {/* ---- Delete Confirmation Modal ---- */}
        <Modal
          show={this.state.showDeleteModal}
          onHide={this.closeDeleteModal}
          centered
          className="af-custom-modal"
        >
          <Modal.Header closeButton className="border-bottom-0 pb-0 pt-4 px-4">
            <Modal.Title className="text-danger h5 font-weight-bold">
              <i className="fas fa-exclamation-triangle mr-2" />
              Delete Form
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-3 px-4 pb-2">
            <p
              className="mb-3"
              style={{ color: "#64748b", fontSize: "14px", lineHeight: "1.5" }}
            >
              Are you sure you want to delete the admission form{" "}
              <strong>{this.state.formToDeleteName}</strong>? This action cannot
              be undone and will remove all configuration settings.
            </p>
            <p
              className="mb-2"
              style={{ color: "#334155", fontSize: "13px", fontWeight: "600" }}
            >
              Please type <strong>{this.state.formToDeleteName}</strong> to
              confirm.
            </p>
            <Form.Control
              type="text"
              value={this.state.deleteConfirmationText}
              onChange={(e) =>
                this.setState({ deleteConfirmationText: e.target.value })
              }
              placeholder="Enter form name"
              style={{ fontSize: "14px", height: "40px" }}
            />
          </Modal.Body>
          <Modal.Footer className="border-top-0 pt-3 pb-4 px-4 d-flex justify-content-end gap-2">
            <button
              className="af-cancel-btn"
              onClick={this.closeDeleteModal}
              disabled={this.state.deleting}
              style={{
                padding: "8px 16px",
                height: "auto",
                fontSize: "14px",
                background: "transparent",
                border: "1px solid #e2e8f0",
                color: "#64748b",
                borderRadius: "6px",
              }}
            >
              Cancel
            </button>
            <button
              className="af-save-btn"
              onClick={this.confirmDelete}
              disabled={
                this.state.deleting ||
                this.state.deleteConfirmationText !==
                this.state.formToDeleteName
              }
              style={{
                padding: "8px 16px",
                height: "auto",
                fontSize: "14px",
                background: "#ef4444",
                border: "1px solid #ef4444",
                color: "#fff",
                borderRadius: "6px",
                opacity:
                  this.state.deleting ||
                    this.state.deleteConfirmationText !==
                    this.state.formToDeleteName
                    ? 0.6
                    : 1,
              }}
            >
              {this.state.deleting ? (
                <span className="spinner-border spinner-border-sm mr-2" />
              ) : null}
              Delete
            </button>
          </Modal.Footer>
        </Modal>
      </Container>
    );
  }
}

export default withRouter(
  compose(graphql(DELETE_ENQUIRY_FORM, { name: "removeEnquiryForm" }))(
    withApollo(AdmissionFormsHome),
  ),
);
